/**
 * Encapsulates parameters used to make requests to [ContextualService].
 */
export class IndicesInfoRequest {
  /**
   * Gets or sets the language (i.e. en-us) for which the response should be returned in.
   */
  public readonly language: string

  /**
   * Initializes a new [IndicesInfoRequest].
   * @param language The language (i.e. en-us) for which the response should be returned in.
   */
  constructor(language: string) {
    this.language = language
  }
}
